import React, { useEffect } from 'react';
import { toCancellable } from '@shared/axios';
import { VtexModal } from './vtex-modal';
import { useVTEX } from './vtex.hooks';

export const Vtex = () => {
    const {
        loading,
        integrationData,
        loadInitialData,
        submitting,
        save,
    } = useVTEX();
    useEffect(() => toCancellable(loadInitialData()), [loadInitialData]);

    return (
        <VtexModal
            onSubmit={save}
            initialData={integrationData}
            isSubmitting={submitting}
            isLoading={loading}
        />
    );
};
